<tgt-modal [witdhModal]="'80%'">
  <main>
    <div class="header">
      <h3>{{turma?.nome}}</h3>
      <!-- <tgt-input-icon [icon]="'search'" [backGround]="'#EEF2E9'" [placeholder]="'Busque aqui'"
        [iconPosition]="'right'"></tgt-input-icon> -->

      <span class="material-symbols-outlined icon" (click)="fechar()">
        close
      </span>
    </div>


    <div class="header-mobile">
      <div class="sup">
        <h3>Chamada</h3>
        <span class="material-symbols-outlined icon" (click)="fechar()">
          close
        </span>
      </div>

      <!-- <tgt-input-icon [icon]="'search'" [backGround]="'#EEF2E9'" [placeholder]="'Busque aqui'"
        [iconPosition]="'right'"></tgt-input-icon> -->


    </div>

    <div class="infos-chamada">
      <tgt-input-icon [control]="form.controls.data" [placeholder]="'Data*'" [type]="'datetime-local'"
        [border]="true"></tgt-input-icon>
      <tgt-select label="Conteúdo*" [error]="camposObrigatorios" [control]="form.controls.grade_curriculars"
        [options]="optionsConteudos" (changeValue)="changeConteudo($event)"></tgt-select>
      <tgt-toggle [label]="'Aula Dupla'" [control]="toggle" (changeToggle)="aulaDupla($event)"></tgt-toggle>
    </div>
    <div class="table">


      <!-- Cabeçalho da Tabela -->
      <table>
        @if(this.alunos.length) {
        <thead border="1" cellspacing="0" cellpadding="10">
          <tr>
            <th class="th">
              <div class="th-info">
                <span class="material-symbols-outlined icone">school</span>
                <p>Aluno</p>
              </div>
            </th>
            <!-- <th class="th">
              <div class="th-info">
                <span class="material-symbols-outlined icone">familiar_face_and_zone</span>
                <p>Escolar (IA)</p>
              </div>
            </th> -->
            <th class="th">
              <div class="th-info">
                <span class="material-symbols-outlined icone">badge</span>
                <p>Aula 1</p>
              </div>
            </th>
            @if(segunda_aula) {
            <th class="th">
              <div class="th-info">
                <span class="material-symbols-outlined icone">badge</span>
                <p>Aula 2</p>
              </div>
            </th>
            }
          </tr>
        </thead>
        }
        <!-- Corpo da Tabela -->
        <tbody>
          @for (item of alunos; track $index) {
          <tr>
            <td>
              <div class="linhaBody">
                {{item.nome}}
              </div>
            </td>
            <!-- <td>
              <span> - - </span>
            </td> -->
            <td>
              @if(item.status['aula 1'] === true) {
              @if(item.presente['aula 1'] === true){
              <div class="chamada-realizada">
                <div></div>
                <div class="presente-chamada">
                  <span class="material-symbols-outlined icon-presente">
                    sentiment_very_satisfied
                  </span>
                  <p>Presente</p>
                </div>
                <span class="material-symbols-outlined edit-presente" (click)="editarChamada(item.id, 'aula 1')">
                  edit
                </span>
              </div>
              } @else {
              <div class="chamada-realizada">
                <div></div>
                <div class="ausente-chamada">
                  <span class="material-symbols-outlined icon-ausente">
                    sentiment_dissatisfied
                  </span>
                  <p>Ausente</p>
                </div>
                <span class="material-symbols-outlined edit-ausente" (click)="editarChamada(item.id, 'aula 1')">
                  edit
                </span>
              </div>
              }
              } @else {
              <div class="linhaBody">
                <div class="linhaBody">
                  <button class="btn-error linhaBody" (click)="formarChamada(item.id, false, 'aula 1')">
                    <span class="material-symbols-outlined falta">sentiment_dissatisfied</span>
                    <label for="">Ausente</label>
                  </button>
                  <button class="btn-succes linhaBody" (click)="formarChamada(item.id, true, 'aula 1')">
                    <span class="material-symbols-outlined presente">sentiment_very_satisfied</span>
                    <label for="">Presente</label>
                  </button>
                </div>
              </div>
              }
            </td>
            @if(segunda_aula) {
            <td>
              @if(item.status['aula 2'] === true) {
              @if(item.presente['aula 2'] === true){
              <div class="chamada-realizada">
                <div></div>
                <div class="presente-chamada">
                  <span class="material-symbols-outlined icon-presente">
                    sentiment_very_satisfied
                  </span>
                  <p>Presente</p>
                </div>
                <span class="material-symbols-outlined edit-presente" (click)="editarChamada(item.id, 'aula 2')">
                  edit
                </span>
              </div>
              } @else {
              <div class="chamada-realizada">
                <div></div>
                <div class="ausente-chamada">
                  <span class="material-symbols-outlined icon-ausente">
                    sentiment_dissatisfied
                  </span>
                  <p>Ausente</p>
                </div>
                <span class="material-symbols-outlined edit-ausente" (click)="editarChamada(item.id, 'aula 2')">
                  edit
                </span>
              </div>
              }
              } @else {
              <div class="linhaBody">
                <div class="linhaBody">
                  <button class="btn-error linhaBody" (click)="formarChamada(item.id, false, 'aula 2')">
                    <span class="material-symbols-outlined falta">sentiment_dissatisfied</span>
                    <label for="">Ausente</label>
                  </button>
                  <button class="btn-succes linhaBody" (click)="formarChamada(item.id, true, 'aula 2')">
                    <span class="material-symbols-outlined presente">sentiment_very_satisfied</span>
                    <label for="">Presente</label>
                  </button>
                </div>
              </div>
              }
            </td>
            }
          </tr>

          }
        </tbody>
      </table>
    </div>

    @if(mostrarActions) {

    <div class="footer">
      <tgt-button [border]="false" [color]="'primary'" [size]="'small'" [fieldButton]="'outline'"
        (click)="fechar()">Cancelar</tgt-button>
      <tgt-button [color]="'primary'" [fieldButton]="'field'" [icon]="'done_all'" (click)="finalizarChamada()">Finalizar
        Chamada</tgt-button>
    </div>

    }


  </main>
</tgt-modal>
